import * as React from 'react';
import DriveSpaceHelper from '@ms/items-view-utilities/lib/string/DriveSpaceHelper';
import { BaseText } from '../baseText/BaseTextField';

/**
 * @public
 */
export interface IFileSizeFieldProps {
  /** The file size in raw number of bytes */
  size: number | undefined;
  /** Whether the field is disabled. */
  isDisabled?: boolean;
  /** aria label of the field. */
  ariaLabel?: string;
}

/**
 * @public
 */
export const FileSizeField: React.StatelessComponent<IFileSizeFieldProps> = (props: IFileSizeFieldProps) => {
  let { size, isDisabled, ariaLabel } = props;

  const sizeText = (typeof size === 'undefined') ? '' : DriveSpaceHelper.getDisplayString(size, { ignoreZero: true });

  if (!ariaLabel) {
    ariaLabel = sizeText;
  }

  return (
    <BaseText
      text={ sizeText }
      isDisabled={ isDisabled }
      ariaLabel={ ariaLabel }
    />
  );
};
